// ===== Vendors =====
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Popover from 'bootstrap/js/dist/popover';
import Tab from 'bootstrap/js/dist/tab';
// import Tooltip from 'bootstrap/js/dist/tooltip';
import swiperManager from './swiperManager';

import '../styles/app.scss';

// ===== App Modules =====
// import ProductCardManager from "./ProductCardManager";

window.swiperManager = swiperManager;


window.bootstrap = {
  Collapse,
  Dropdown,
  Modal,
  Offcanvas,
  Popover,
  Tab,
  // Tooltip
};

// ===== Utils =====
const getMetaPageType = () => {
  try { return window.meta?.page?.pageType || ''; } catch { return ''; }
};
// const isCollectionPage = () => getMetaPageType() === 'collection';
// const isProductPage   = () => getMetaPageType() === 'product';



// ===== DOM Ready =====
// document.addEventListener('DOMContentLoaded', () => {
//   new HeaderManager();


// });


